// Visible validation summary shown at the top of a step after a Continue
// attempt fails. Without it, a blocked submit looks like a dead button.
export default function ErrorBanner({ show, messages }) {
  if (!show || !messages || messages.length === 0) return null
  return (
    <div className="step-error-banner field-error" role="alert" aria-live="assertive">
      <strong className="step-error-banner-title">Please fix the following to continue:</strong>
      <ul className="step-error-banner-list">
        {messages.map((m, i) => (
          <li key={i}>{m}</li>
        ))}
      </ul>
    </div>
  )
}
